import { render, staticRenderFns } from "./NotaFiscalDashboard.vue?vue&type=template&id=9fa87ef4&scoped=true&"
import script from "./NotaFiscalDashboard.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NotaFiscalDashboard.vue?vue&type=style&index=0&id=9fa87ef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa87ef4",
  null
  
)

export default component.exports